import * as React from 'react';

import Page from 'components/page/Page';
import InfluencerCreateProfile from 'modules/influencers/components/influencer-create-profile/InfluencerCreateProfile';

import { t } from 'utils/language';

const InfluencerCreateProfilePage = (): JSX.Element => (
  <Page
    documentTitle={t('create_profile_page')}
    customStyle={{ marginTop: 0 }}
  >
    <InfluencerCreateProfile />
  </Page>
);

export default InfluencerCreateProfilePage;
